import { ContentNavigation } from "@carfax/web-ui/components/ContentNavigation/ContentNavigation";
import { ModuleContentNavigation } from "@carfax/contentful/PageModularModule";

interface Props {
  module: ModuleContentNavigation;
}

export const ContentNavigationModule = ({ module }: Props) => {
  const items = module.items.map((item) => ({
    label: item.label,
    url: item.url,
    icon: item.icon ? <img src={item.icon.url} alt={item.icon.title || ""} width={24} height={24} /> : undefined,
  }));

  return (
    <ContentNavigation
      badge={module.badge}
      headline={module.headline}
      headingLevel={module.headingLevel}
      items={items}
    />
  );
};
